var map = {
	"./arteza.png": 69765,
	"./avis.png": 331,
	"./club-mahindra.png": 77487,
	"./coupang.png": 62731,
	"./croma.png": 69576,
	"./kisan-konnect.png": 55935,
	"./licious.png": 62239,
	"./licious2.png": 40548,
	"./licious3.png": 3789,
	"./licious4.png": 73810,
	"./licious5.png": 95355,
	"./licious6.png": 97792,
	"./logitech.png": 97829,
	"./nykaa-fashions.png": 88132,
	"./nykaa.png": 7628,
	"./shoppers-stop.png": 75529,
	"./star.png": 70422,
	"./vijay-sales.png": 24962,
	"./wonderchef.png": 15887
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27573;